import { Popover } from 'bootstrap';

/**
 * Initializes popovers based on the current UI framework (Bootstrap 3 or Bootstrap 5).
 */

export function initPopovers() {
    const isLegacy = $('body').hasClass('legacy-master');

    // --- CRITICAL FIX: AGGRESSIVE ISOLATION ---
    // If we are in Legacy Mode, we MUST ensure $.fn.popover is Bootstrap 3.
    // If it detects Version 5, we run .noConflict() to strip BS5 and restore BS3.
    if (isLegacy && $.fn.popover && $.fn.popover.Constructor.VERSION.startsWith('5')) {
        $.fn.popover.noConflict();
    }

    // Only target our custom component class to prevent framework collisions
    const triggerSelector = '.js-x-popover';

    const getPopoverContent = function(el) {
        const $triggerEl = $(el);
        const targetSelector = $triggerEl.attr('data-pop-target');

        // Clone content from a hidden div
        if (targetSelector && $(targetSelector).length) {
            return $(targetSelector).clone(true).removeAttr('style').removeClass('d-none hidden');
        }

        // Fallback to content in content attribute
        return $triggerEl.attr('data-pop-content') || '';
    };

    if(isLegacy) { // bs3

        $('body').popover({
            selector: triggerSelector,
            container: 'body',
            html: true,
            sanitize: false,
            trigger: 'click',
            placement: function() { return $(this).attr('data-pop-placement') || 'bottom'; },
            title: function() { return $(this).attr('data-pop-title'); },
            content: function() { return getPopoverContent(this); }
        });

        // Toggle ARIA on shown/hidden
        $(document)
            .on('shown.bs.popover', triggerSelector, function() {
                const $trigger = $(this);
                $trigger.attr('aria-expanded', 'true').addClass('showing');

                const popoverId = $trigger.attr('aria-describedby');
                const $popoverEl = $(`#${popoverId}`);

                $popoverEl.on('click', '.close-pop, .closePop, #closePop', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $trigger.popover('hide');
                    const popoverData = $trigger.data('bs.popover');
                    if (popoverData) {
                        popoverData.hide();
                        if (popoverData.inState) {
                            popoverData.inState.click = false;// BS3 Hack: reset internal state to allow reopening
                        }
                    }
                });

                // BS3 specific: Sometimes the 'click' state gets stuck
                const data = $trigger.data('bs.popover');
                if (data && data.inState) data.inState.click = true;
            })
            .on('hidden.bs.popover', triggerSelector, function() {
                $(this).attr('aria-expanded', 'false').removeClass('showing');
            });

    } else { //bs5
        const targets = document.querySelectorAll(triggerSelector);

        targets.forEach(el => {
            if (!Popover.getInstance(el)) {
                const popoverInstance = new Popover(el, {
                    container: 'body',
                    html: true,
                    sanitize: false,
                    trigger: 'click',
                    placement: el.getAttribute('data-pop-placement') || 'bottom',
                    title: el.getAttribute('data-pop-title'),
                    content: () => getPopoverContent(el)
                });

                el.addEventListener('shown.bs.popover', () => {
                    el.setAttribute('aria-expanded', 'true');
                    el.classList.add('showing');

                    const popoverId = el.getAttribute('aria-describedby');
                    const popoverEl = document.getElementById(popoverId);

                    if (popoverEl) {
                        // Use jQuery for consistent event delegation inside the popover element
                        $(popoverEl).on('click', '.close-pop, .closePop, #closePop', (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            Popover.getInstance(el)?.hide();
                        });
                    }
                });

                el.addEventListener('hidden.bs.popover', () => {
                    el.setAttribute('aria-expanded', 'false');
                    el.classList.remove('showing');
                });
            }
        });
    }

    // --- GLOBAL: CLICK OUTSIDE TO CLOSE ---
    $(document).on('click', function(e) {
        const $target = $(e.target);

        if (!$target.closest('.popover').length && !$target.closest(triggerSelector).length) {
            $(triggerSelector + '[aria-expanded="true"]').each(function(_, el) {
                if (isLegacy) {
                    $(el).popover('hide');

                    // Manual state reset for BS3 ghosting
                    const popoverData = $(this).data('bs.popover');
                    if (popoverData) {
                        popoverData.hide();
                        if (popoverData.inState) {
                            popoverData.inState.click = false;
                        }
                    }
                } else {
                    Popover.getInstance(el)?.hide();
                }
            });
        }
    });
}

$(document).ready(function() {
    initPopovers();

    $(document).ajaxComplete(() => {
        // BS3 uses delegation, so it only needs to re-init on Modern views
        if (!$('body').hasClass('legacy-master')) {
            initPopovers();
        }
    });
});